import { render, staticRenderFns } from "./PanelActions.vue?vue&type=template&id=952c4678&"
import script from "./PanelActions.vue?vue&type=script&lang=js&"
export * from "./PanelActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports